(() => {
  'use strict';
  const root = window.Shopify?.routes?.root || '/';
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  const labels = () => window.FurAwayStrings || {};
  const announce = (message) => { const node = $('#StoreStatus'); if (node) node.textContent = message; };
  let opener = null;
  let busy = false;
  let cartReady = true;
  const drawer = () => $('#CartDrawer');
  const setLocked = (locked) => {
    busy = locked;
    $$('[data-cart-content] input, [data-cart-content] button, [data-product-form] button[type="submit"]').forEach(node => {
      if (locked) { node.dataset.previouslyDisabled = String(node.disabled); node.disabled = true; }
      else if (node.dataset.previouslyDisabled !== undefined) { node.disabled = node.dataset.previouslyDisabled === 'true'; delete node.dataset.previouslyDisabled; }
    });
    $$('[data-cart-content]').forEach(node => node.setAttribute('aria-busy', String(locked)));
  };
  const attachDrawer = () => {
    const node = drawer();
    if (!node || node.dataset.bound) return;
    node.dataset.bound = 'true';
    node.addEventListener('close', () => { document.body.classList.remove('drawer-open'); opener?.focus(); });
    node.addEventListener('click', (event) => {
      if (event.target !== node) return;
      const bounds = node.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) node.close();
    });
  };
  const openDrawer = () => {
    const node = drawer();
    if (!node?.showModal || !cartReady) { window.location.assign(`${root}cart`); return; }
    attachDrawer();
    if (!node.open) { node.showModal(); document.body.classList.add('drawer-open'); }
  };
  const sectionIds = () => [drawer()?.dataset.sectionId, $('[data-main-cart-section]')?.dataset.mainCartSection].filter(Boolean);
  const renderCart = (data) => {
    const previousFocus = document.activeElement;
    const focusKey = previousFocus?.closest('[data-line-key]')?.dataset.lineKey;
    const focusType = previousFocus?.matches('[data-cart-quantity]') ? '[data-cart-quantity]' : previousFocus?.matches('[data-cart-step]') ? `[data-cart-step="${previousFocus.dataset.cartStep}"]` : null;
    const docParser = new DOMParser();
    let drawerRendered = false;
    for (const html of Object.values(data.sections || {})) {
      if (!html) continue;
      const parsed = docParser.parseFromString(html, 'text/html');
      const newDrawer = $('#CartDrawer', parsed);
      if (newDrawer && drawer()) { drawer().innerHTML = newDrawer.innerHTML; drawerRendered = true; }
      const newPage = $('[data-main-cart-section]', parsed);
      const oldPage = $('[data-main-cart-section]');
      if (newPage && oldPage) oldPage.innerHTML = newPage.innerHTML;
    }
    if (drawerRendered) cartReady = true;
    const count = data.item_count ?? Number($('[data-cart-content]')?.dataset.itemCount || 0);
    $$('[data-cart-count]').forEach(node => { node.textContent = String(count); });
    if (focusKey && focusType) {
      const scope = drawer()?.open ? drawer() : $('[data-main-cart-section]');
      const line = scope && $$('[data-line-key]', scope).find(node => node.dataset.lineKey === focusKey);
      if (line) $(focusType, line)?.focus(); else if (drawer()?.open) $('[data-cart-close]', drawer())?.focus();
    }
    return drawerRendered;
  };
  const request = async (url, options) => {
    const response = await fetch(url, { credentials: 'same-origin', ...options });
    const body = await response.json();
    if (!response.ok || body.status >= 400) {
      const detail = typeof body.description === 'string' ? body.description : typeof body.message === 'string' ? body.message : labels().error;
      throw new Error(detail);
    }
    return body;
  };
  const showError = (node, message) => { if (node) { node.hidden = false; node.textContent = message || labels().error; } announce(message || labels().error); };
  const refreshCart = async () => {
    const sections = sectionIds();
    const data = await request(`${root}cart.js`);
    const url = new URL(window.location.href);
    url.search = '';
    url.searchParams.set('sections', sections.join(','));
    data.sections = await request(url.toString());
    return renderCart(data);
  };
  const changeCart = async (key, quantity) => {
    if (busy) return;
    $$('[data-cart-error]').forEach(node => node.hidden = true);
    setLocked(true);
    try {
      const data = await request(`${root}cart/change.js`, {
        method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({id:key, quantity, sections:sectionIds(), sections_url:window.location.pathname})
      });
      if (!renderCart(data)) await refreshCart();
      announce(labels().updated);
    } catch (error) {
      try { await refreshCart(); } catch { cartReady = false; }
      const scope = drawer()?.open ? drawer() : document;
      showError($('[data-cart-error]', scope), error.message);
    } finally { setLocked(false); }
  };
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;
    event.preventDefault();
    if (busy || form.closest('[data-product-root]')?.getAttribute('aria-busy') === 'true') return;
    if (!form.reportValidity()) return;
    const errorNode = $('[data-form-error]', form);
    if (errorNode) errorNode.hidden = true;
    const body = new FormData(form);
    body.set('sections', sectionIds().join(','));
    body.set('sections_url', window.location.pathname);
    opener = $('button[type="submit"]', form);
    setLocked(true);
    try {
      const data = await request(`${root}cart/add.js`, {method:'POST',headers:{Accept:'application/json'},body});
      cartReady = false;
      if (!renderCart(data)) await refreshCart();
      announce(labels().added);
      openDrawer();
    } catch (error) {
      cartReady = false;
      showError(errorNode, error.message);
    } finally { setLocked(false); }
  });
  document.addEventListener('click', (event) => {
    const open = event.target.closest('[data-cart-open]');
    if (open && drawer()?.showModal) { event.preventDefault(); opener = open; openDrawer(); return; }
    if (event.target.closest('[data-cart-close]')) { drawer()?.close(); return; }
    const quantityButton = event.target.closest('[data-quantity-step]');
    if (quantityButton) {
      const input = $('input', quantityButton.closest('.quantity-control'));
      if (Number(quantityButton.dataset.quantityStep) > 0) input.stepUp(); else input.stepDown();
      input.dispatchEvent(new Event('change', {bubbles:true}));
      return;
    }
    const remove = event.target.closest('[data-cart-remove]');
    const cartStep = event.target.closest('[data-cart-step]');
    if (remove || cartStep) {
      event.preventDefault();
      if (busy) return;
      const line = (remove || cartStep).closest('[data-line-key]');
      const input = $('[data-cart-quantity]', line);
      if (remove) { changeCart(line.dataset.lineKey, 0); return; }
      const value = Number(input.value);
      const increment = Number(input.step) || 1;
      const minimum = Number(input.min) || 1;
      let quantity = value + Number(cartStep.dataset.cartStep) * increment;
      if (quantity < minimum) quantity = 0;
      if (input.max && quantity > Number(input.max)) return;
      changeCart(line.dataset.lineKey, quantity);
      return;
    }
    const thumb = event.target.closest('[data-gallery-image]');
    if (thumb) {
      const gallery = thumb.closest('.product-gallery');
      const current = $('.gallery-main img', gallery);
      if (!current) return;
      event.preventDefault();
      current.src = thumb.dataset.galleryImage;
      current.removeAttribute('srcset');
      current.alt = thumb.dataset.imageAlt || '';
      $$('.gallery-thumbnail', gallery).forEach(node => node.removeAttribute('aria-current'));
      thumb.setAttribute('aria-current', 'true');
    }
  });
  let optionRequest;
  document.addEventListener('change', async (event) => {
    if (event.target.matches('[data-cart-quantity]')) {
      const input = event.target;
      if (!input.checkValidity() || busy) { if (!busy) input.reportValidity(); return; }
      changeCart(input.closest('[data-line-key]').dataset.lineKey, Number(input.value));
      return;
    }
    if (!event.target.matches('[data-option-selector]')) return;
    const oldRoot = event.target.closest('[data-product-root]');
    const optionIds = $$('[data-option-selector]', oldRoot).map(node => node.value);
    const focusId = event.target.id;
    optionRequest?.abort();
    const controller = new AbortController();
    optionRequest = controller;
    oldRoot.setAttribute('aria-busy','true');
    $$('button[type="submit"], .shopify-payment-button button', oldRoot).forEach(node => { node.disabled = true; });
    const url = new URL(oldRoot.dataset.productUrl, window.location.origin);
    url.searchParams.set('option_values', optionIds.join(','));
    url.searchParams.set('section_id', oldRoot.dataset.sectionId);
    try {
      const response = await fetch(url, {signal:controller.signal});
      if (!response.ok) throw new Error(labels().variantError);
      const doc = new DOMParser().parseFromString(await response.text(),'text/html');
      const newRoot = $('[data-product-root]', doc);
      if (!newRoot) throw new Error(labels().variantError);
      $$('noscript', newRoot).forEach(node => node.remove());
      oldRoot.replaceWith(newRoot);
      $$('[data-variant-input]', newRoot).forEach(node => { node.disabled = false; });
      document.getElementById(focusId)?.focus();
      const visibleUrl = new URL(window.location.href);
      visibleUrl.searchParams.delete('option_values');
      if (newRoot.dataset.variantId) visibleUrl.searchParams.set('variant',newRoot.dataset.variantId);
      else { visibleUrl.searchParams.delete('variant'); visibleUrl.searchParams.set('option_values',optionIds.join(',')); }
      history.replaceState({},'',visibleUrl);
      document.dispatchEvent(new CustomEvent('furaway:variant-change',{detail:{variantId:newRoot.dataset.variantId,section:newRoot}}));
      window.Shopify?.PaymentButton?.init();
    } catch (error) {
      if (error.name !== 'AbortError') {
        url.searchParams.delete('section_id');
        window.location.assign(url.toString());
      }
    }
  });
  const recommendationObserver = new IntersectionObserver((entries, observer) => {
    entries.filter(entry => entry.isIntersecting).forEach(async ({target}) => {
      observer.unobserve(target);
      try {
        const response = await fetch(target.dataset.url);
        if (!response.ok) return;
        const parsed = new DOMParser().parseFromString(await response.text(),'text/html');
        const content = $('[data-recommendations]',parsed);
        if (content?.querySelector('.product-card')) target.innerHTML = content.innerHTML;
        else target.hidden = true;
      } catch { target.hidden = true; }
    });
  }, {rootMargin:'200px'});
  const initialize = () => { $$('[data-variant-input]').forEach(node => { node.disabled = false; }); attachDrawer(); $$('[data-recommendations]').forEach(node => recommendationObserver.observe(node)); };
  document.addEventListener('shopify:section:load', initialize);
  initialize();
})();
